<template>
<!-- 
  Author: lan.h
  Date: 2021-10-21
  content: 历届发布
-->
  <div class="vb100">
    <div class="p_head">
      <div class="p_title">
        <p>VB100</p>
        <h1>{{year_index.name}}</h1>
      </div>
      <div class="p_links">
        <div class="links-item js-lower-anchor" v-for="item in year_list"  @click="yearChange(item)">
          <p class="links-name" :class="item.id == year_index.id ? 'y_active' : ''">{{item.name}}</p>
        </div>
      </div>
    </div>
    <div class="banner_name">
        <span v-for="item, index in year_index.banner" :key="index" :class="banner_index.id == item.id ? 'active' : ''" @click="bannerChane(item)">{{item.name}}</span>
    </div>
    <div class="p_image p_image_ani" :key="banner_index.logo_path">
      <div class="p_image_inner">
        <img id="p_image" class="animate__animated" :src="banner_index.logo_path | logo" @click="bannerTo()">
      </div>
    </div>
    <!-- 历届榜单 -->
    <div class="his-content" id="list-table">
      <div class="list-content">
        <div class="info">
          <div class="list-title">历届榜单</div>
          <div class="list-png">
            <img src="~/img/main/list.png" />
          </div>
        </div>
        <div class="table-title">
          <div>
            <img src="~/img/main/list-left.png" />
            <div>
              <h1>{{detail.title}}</h1>
              <p>{{year_index.name}}</p>
            </div>
            <img src="~/img/main/list-right.png" />
          </div>
        </div>
        <!-- 表格 -->
        <div class="list-wap release">
          <div class="list-table" ref="table">
            <el-table ref="filterTable" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)" :data="tableData" :header-cell-style="{background:'#2A2F42', color: '#E9E9EB'}" :key="key_index">
              <template v-for="item,index in columns">
                <!-- 实体 -->
                <el-table-column align="center" v-if="item.type == 3" :prop="'col' + index" :label="item.name">
                  <template slot-scope="scope">
                    <div class="table-td">
                      <!-- 动脉橙 -->
                      <p v-if="detail.jump != '0'" class="over-p2">
                        <el-tooltip v-if="getResult(scope.row, detail.jump).description" class="item" effect="dark" :content="getResult(scope.row, detail.jump).description" placement="top">
                          <a v-if="getResult(scope.row, detail.jump).url" class="main_page" :href="getResult(scope.row, detail.jump).url" target="_blank">
                            <span>{{scope.row['col'+index]}}</span>
                          </a>
                          <span v-else>{{scope.row['col'+index]}}</span>
                        </el-tooltip>
                        <span v-else>
                          <a v-if="getResult(scope.row, detail.jump).url" class="main_page" :href="getResult(scope.row, detail.jump).url" target="_blank">
                            <span>{{scope.row['col'+index]}}</span>
                          </a>
                          <span v-else>{{scope.row['col'+index]}}</span>
                        </span>
                      </p>
                      <!-- 官网 -->
                      <!-- <p v-else-if="detail.jump == '2'" class="over-p2">
                        <a v-if="getResult(scope.row, '2')" class="main_page" :href="getResult(scope.row, '2')" target="_blank">{{scope.row['col'+index]}}</a>
                        <span v-else>{{scope.row['col'+index]}}</span>
                      </p> -->
                      <!-- 不跳转 -->
                      <p v-else class="over-p2">
                        <el-tooltip v-if="getResult(scope.row, detail.jump).description" class="item" effect="dark" :content="getResult(scope.row, detail.jump).description" placement="top">
                          <span>{{scope.row['col'+index]}}</span>
                        </el-tooltip>
                        <span v-else>{{scope.row['col'+index]}}</span>
                      </p>
                    </div>
                  </template>
                </el-table-column>
                <!-- 排序 -->
                <el-table-column align="center" v-else-if="item.type == 1" :prop="'col' + index" :label="item.name" sortable>
                  <template slot-scope="scope">
                    <div class="table-td">
                      <p class="over-p2">{{scope.row['col'+index]}}</p>
                    </div>
                  </template>
                </el-table-column>
                <!-- 筛选 -->
                <el-table-column align="center" v-else-if="item.type == 2" :prop="'col' + index" :label="item.name" :filters="item.temp_arr" :filter-multiple="false" :filter-method="filterHandler">
                  <template slot-scope="scope">
                    <div class="table-td">
                      <p class="over-p2">{{scope.row['col'+index]}}</p>
                    </div>
                  </template>
                </el-table-column>
                <!-- 普通字段 -->
                <el-table-column align="center" v-else :prop="'col' + index" :label="item.name">
                  <template slot-scope="scope">
                    <div class="table-td">
                      <p class="over-p2">{{scope.row['col'+index]}}</p>
                    </div>
                  </template>
                </el-table-column>
              </template>
            </el-table>
            <div class="remark" v-html="detail.remarks"></div>
          </div>
          <!-- 锚点 -->
          <div class="anchor-wap">
            <ul class="anchor">
              <li class="anchor-item year"><div>{{year_index.name}}</div></li>
              <el-collapse v-model="awards" accordion>
                <el-collapse-item v-for="item in anchor_list" :key="item.id" :title="item.name" :name="item.id">
                  <div class="anchor-item-title" :class="key_index == b.id ? 'anchor-item-active' : ''" v-for="b in item.arr" :key="b.id"  @click="openYear(b)">{{b.title}}</div>
                </el-collapse-item>
              </el-collapse>
              <!-- <li class="anchor-item" v-for="item in anchor_list" :key="item.id" @click="openYear(item)">
                <div class="anchor-item-title">
                    <span :class="detail.id == item.id ? 'anchor-item-active' : ''">{{item.title}}</span>
                </div>
              </li> -->
              <li class="anchor-bottom"></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getVBBannerList, getVbTopListByYear } from '@/service/main.js'
import { list_mixin, scroll_mixin } from 'js/list_mixins'
export default{
  mixins: [list_mixin, scroll_mixin],
  data() {
    return {
      year_list: [], //年份数组
      year_list_copy: [], //年份数组 原始
      year_index: {}, //当前年
      banner_index: {}, //当前吧banner
      tableData: [], //表格数据
      columns: [], //表头数组
      loading: false, 
      anchor_list: [], //锚点数组

      detail: '',
      key_index: '',
      awards: ''

    }
  },
  computed: {
    list_meta() {
      return this.$store.state.list_meta
    },
    awards_id() {
      let id = this.$store.state.list_meta.awards_meta.find(item => item.route == this.$route.name).id
      return id
    }
  },
  mounted() {
    let _this = this
    this.$nextTick(() => {
      window.onscroll = () => {
        _this.listenerScroll('anchor', 20)
      }
      window.onresize = () => {
        _this.listenerScroll('anchor', 20)
      }
    })
  },
  beforeDestroy(){
    window.onscroll = null
    window.onresize = null
  },
  created() {
    this.getVBBannerList()
  },
  methods: {
    //banner跳转
    bannerTo() {
      if(this.banner_index.url){
         window.open(this.banner_index.url, '_blank')
      }
    },
    // 年份切换
    yearChange(item) {
      // let arr = [...this.year_list_copy]
      // let index = arr.findIndex(i => i.id == item.id)
      // arr.splice(index, 1)
      // this.year_list = arr

      this.year_index = item
      this.banner_index =  item.banner.length > 0 ?  item.banner[0] : {}
      this.getVbTopListByYear(item.id)
    },
    //banner切换
    bannerChane(item) {
      this.banner_index = item
      // $('#p_image').addClass('animate__pulse')
      // var x = document.getElementById("p_image")
      // x.addEventListener('animationend', function(){
      //   $('#p_image').removeClass('animate__pulse')
      // })
    },
    //获取年数据
    async getVBBannerList() {
      let res = await getVBBannerList({}, (error) => { this.$Message.error('请求错误') })
      if (res.status == 'success') {
        this.$set(this.$data, 'year_list', res.res)
        this.year_list_copy =  JSON.parse(JSON.stringify(res.res))
        if(res.res.length > 0){
          this.year_index = res.res[0]
          // this.year_list.splice(0, 1)
          this.banner_index = this.year_index.banner.length > 0 ? this.year_index.banner[0] : {}
          this.getVbTopListByYear(this.year_index.id)
        }
      } else {
        this.$Message.error(res.msg)
      }
    },
    //获取表格数据
    async getVbTopListByYear(awards_year_id) {
      this.loading = true
      let res = await getVbTopListByYear({
        awards_year_id: awards_year_id,
        type: 1
      }, (error) => { this.$Message.error('请求错误') })
      if (res.status == 'success') {
        let awards_meta = []
        this.list_meta.awards_meta.forEach(item => {
          let arr = res.res.filter(e => e.awards_id == item.id) || []
          if(arr.length > 0){
            awards_meta.push({...item, arr: arr})
          }
        });
        this.$set(this.$data, 'anchor_list', awards_meta)
        if(awards_meta.length > 0){
          this.awards = awards_meta[0].id
          let deal_temp = this.dealList(awards_meta[0].arr[0].content)
          this.key_index = awards_meta[0].arr[0].id
          this.$set(this.$data, 'tableData', deal_temp.arr)
          this.$set(this.$data, 'columns', deal_temp.col_list)
          this.$set(this.$data, 'detail', awards_meta[0].arr[0])
          this.matching_results = awards_meta[0].arr[0].matching_results ? JSON.parse(awards_meta[0].arr[0].matching_results) : []
        }
        this.loading = false
      } else {
        this.$Message.error(res.msg)
      }
    },
    //点击榜单
    openYear(item) {
      $("html,body").animate({ scrollTop: $('#list-table').offset().top - 80 }, 500)
      this.key_index = item.id
      this.detail = item
      let deal_temp = this.dealList(item.content)
      this.$set(this.$data, 'tableData', deal_temp.arr)
      this.$set(this.$data, 'columns', deal_temp.col_list)
      this.$set(this.$data, 'detail', item)
      this.matching_results = item.matching_results ? JSON.parse(item.matching_results) : []
    },
    //表格筛选
    filterHandler(value, row, column) {
      const property = column['property']
      return row[property] === value
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~css/main/list.stylus';
.y_active
  color #D9BB9E
.p_head 
  .p_links 
    .links-item
      width 100px
      height 30px
.banner_name
  width 75%
  margin-top 40px
  margin-left auto
  margin-right auto
  span 
    margin-right 40px
    font-size 14px
    font-weight bold
    color #E9E9EB
    line-height 22px
    cursor pointer
  .active
    color #D9BB9E
    border 1px solid #D9BB9E
    border-radius 13px
    padding 6px 12px
.p_image
  transition all .5s
  // .p_image_inner
  //   img 
  //     transition all .5s
.release
  .anchor-wap
    .anchor
      >>>.el-collapse
        padding 0 20px 10px 20px
        background #1f2330
        border 0
        .el-collapse-item__header.is-active
          background #1f2330
        .el-collapse-item__wrap
          background #1f2330
          border-bottom 1px solid #30343D
        .el-collapse-item__header
          background #1f2330
          border-bottom 1px solid #30343D
          color #E9E9EB
        .anchor-item-title
          padding 10px 0
          line-height 18px
          color #BCBDC1
          font-size 13px
          font-weight 500
          cursor pointer
          &:hover
            color #D9BB9E
          &:last-child
            padding-bottom 0
        .anchor-item-active 
          color #D9BB9E
      .anchor-item
        border-bottom 0
        padding 0 20px 0 20px
      .year
        padding 20px 20px 10px 20px
        >div
          border-bottom 1px solid #D9BB9E
          padding-bottom 20px
          font-size 14px
          font-weight 800
          color #E9E9EB
          line-height 1
@media screen and (max-width: 1200px)
  .banner_name
    width calc(100% - 160px)
@media screen and (min-width: 1601px)
  .banner_name
    width 62%
</style>